var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block px-[10px] py-[3px] rounded-full text-[12px] font-medium",style:({ color: _vm.config.style.color, background: _vm.config.style.background })},[_vm._v(" "+_vm._s(_vm.config.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }